import { Component, EventEmitter, OnInit } from '@angular/core';
import { SchoolIntegrationCompletionResponse } from '../../models/school-integration-completion-response.model';
import { DwButtonCommand, DwButtonConfig, DwMessage, DwMessageSeverity, DwModalConfig, DwModalHandler, DwModalResult } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import IntegrationRepositoryService from '../../services/integration-repository.service';
import { SchoolIntegrationCompletionRequest } from '../../models/school-integration-completion-request.model';
import { SchoolIntegrationResponse, SchoolIntegrationResponseType } from '../../models/school-integration-response.model';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-create-school-modal',
  templateUrl: './create-school-modal.component.html',
  styleUrls: ['./create-school-modal.component.scss']
})
export class CreateSchoolModalComponent implements OnInit, DwModalHandler {

  response: SchoolIntegrationResponse;
  request: SchoolIntegrationCompletionRequest;


  constructor(private integrationRepository: IntegrationRepositoryService) { }

  modalConfig: DwModalConfig<SchoolIntegrationResponse>;
  closeModal: EventEmitter<DwModalResult<any>>;
  message: DwMessage;

  ngOnInit(): void {

    this.response = this.modalConfig.data;

    this.request = {
      FlightSchoolName: this.response.FlightSchoolName,
      Location: this.response.Location,
      ResponseType: SchoolIntegrationResponseType.CreateNewSchool,
      IntegrationRequestToken: this.modalConfig.data.IntegrationRequestToken,
    }
  }


  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult> {
    const result = new DwModalResult();
    result.cancelled = false;

    switch (buttonConfig.command) {
      case DwButtonCommand.ok:
      case DwButtonCommand.saveAndClose:
      case DwButtonCommand.save:
        return this.completeSchoolCreation();
      case DwButtonCommand.cancel:
        result.closeModal = true;
        result.cancelled = true;
    }
    return of(result);
  }


  completeSchoolCreation(): Observable<DwModalResult<any>> {
    const result = new DwModalResult();
    return this.integrationRepository.completeSchoolIntegration(this.request, this.modalConfig.data)
      .pipe(map((response) => {
        if (!response.Success) {
          this.message = {
            messageBody: response.Message,
            severity: DwMessageSeverity.error,
          }

          result.cancelled = true;
        } else {
          result.closeModal = true;

          this.integrationRepository.handlecompleteSchoolIntegrationResponse(response, this.modalConfig.data);
        }

        return result;
      }));
  }

}
